import smartReplyService from '@/modules/bizai/services/smartReplyService';

const state = {
  isLoading: false,
  replyContent: {
    email_message: '',
    FB_message: '',
    other_message: '',
    sms_message: '',
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
  replyContent: (state) => state.replyContent,
};

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = Boolean(isLoading);
  },
  setReplyContent(state, content) {
    state.replyContent = {
      email_message: content.email_message || '',
      FB_message: content.FB_message || '',
      other_message: content.other_message || '',
      sms_message: content.sms_message || '',
    };
  },
  clearReplyContent(state) {
    state.replyContent = {
      email_message: '',
      FB_message: '',
      other_message: '',
      sms_message: '',
    };
  },
};

const actions = {
  async loadSmartReply({ commit }, matterUid) {
    commit('setLoading', true);
    try {
      const smartReplies = await smartReplyService.listSmartReplies(matterUid, 1, 1);
      const isSmartReplyAvailable = smartReplies && smartReplies.length > 0;
      if (isSmartReplyAvailable) {
        const latestReply = smartReplies[0];
        commit('setReplyContent', latestReply);
        return latestReply;
      }
      commit('clearReplyContent');
      return null;
    } catch (error) {
      commit('clearReplyContent');
      return error;
    } finally {
      commit('setLoading', false);
    }
  },
  async generateSmartReply({ commit }, { matterUid, userInputReferenceId, clientUid, populatedText, customInstructions }) {
    commit('setLoading', true);
    try {
      const smartReply = await smartReplyService.createSmartReply(
        matterUid,
        userInputReferenceId,
        clientUid,
        populatedText,
        customInstructions,
      );
      commit('setReplyContent', smartReply);
      return smartReply;
    } catch (error) {
      return  error;
    } finally {
      commit('setLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
